export const CONSTANTS = {
  TITLE: "You will be checked out soon!",
  SUBTITLE: "step-away will end in 2 minutes.",
  BUTTON_TEXT: "Step In"
};
